import { CopyIcon } from "lucide-react";

// Componente para texto copiável
export const CopyableText = ({ text }: { text: string }) => (
  <div className="flex items-center justify-between bg-white p-2 rounded border text-xs font-mono">
    <span className="truncate pr-2">{text}</span>
    <button
      onClick={() => navigator.clipboard.writeText(text)}
      className="text-blue-600 hover:text-blue-800 transition-colors"
      title="Copiar"
    >
      <CopyIcon className="h-4 w-4" />
    </button>
  </div>
);